import React, { useEffect } from 'react'
import { Switch, Route, Redirect, BrowserRouter } from 'react-router-dom'
import { Home } from './Home'
import { Login } from '../pages/Auth'
import { NovaSenha } from '../pages/NovaSenha/NovaSenha'
import { MatricularAluno } from '../pages/UsuariosCurso'

import { EsqueceuSenha } from '../pages/EsqueceuSenha/EsqueceuSenha'
import { ToastContainer } from 'react-toastify'
import axios from 'axios'
import { useAuthDispatch } from '../stores/hooks'
import { authThunks } from '../stores/authStore'
import '../App.css'
import { Toaster } from 'sonner'

axios.defaults.baseURL = import.meta.env.VITE_API_URL
axios.defaults.withCredentials = true
axios.defaults.headers.common.platform = 'PAINEL'
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

const SessionCheck = () => {
  const dispatch = useAuthDispatch()

  useEffect(() => {
    dispatch(authThunks.checkSession())
  }, [])

  return null
}

export function App() {
  return (
    <>
      <BrowserRouter basename="/">
        <SessionCheck />
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/nova-senha/:token(\w+)" component={NovaSenha} />
          <Route path="/esqueceu-senha" component={EsqueceuSenha} />
          <Route exact path="/pe/matricular" component={MatricularAluno} />
          <Route exact path="/" render={() => <Redirect to="/inicio" />} />
          <Route path="/" component={Home} />
        </Switch>
      </BrowserRouter>
      <ToastContainer style={{ marginTop: '40px' }} />
      <Toaster position="top-right" />
    </>
  )
}
